import { Component, Type } from '@angular/core';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { ExamPropertiesTabNames } from 'src/app/services/exam/enums/properties-tab-names';
import { ExamSettingsTabService } from 'src/app/services/exam/exam-settings-tab.service';
import { IGetClass, IModalWindow, ISetOptions } from 'src/app/utils/interfaces/modal-dialog.interface';
import { IExamModel } from '../interfaces';
import { ExamPropertiesFooterComponent } from '../exam-properties-footer/exam-properties-footer.component';
import { ExamPropertiesViewComponent } from '../exam-properties-view/exam-properties-view.component';
import { ExamPropertiesHeaderComponent } from '../exam-properties-header/exam-properties-header.component';
import { ExamPropertiesSidebarComponent } from '../exam-properties-sidebar/exam-properties-sidebar.component';

export enum ExamPropertiesType {
  create,
  edit,
  readOnly
}

export interface ExamPropertiesOptions {
  // if undefined, open at document
  currentTab: ExamPropertiesTabNames | undefined;
  exam: IExamModel | undefined;
  type: ExamPropertiesType;
}

@Component({
    selector: 'asg-exam-properties',
    templateUrl: './exam-properties.component.html',
    styleUrls: ['./exam-properties.component.scss'],
    standalone: true,
    imports: [ExamPropertiesSidebarComponent, ExamPropertiesHeaderComponent, ExamPropertiesViewComponent, ExamPropertiesFooterComponent]
})

export class ExamPropertiesComponent implements IModalWindow, ISetOptions, IGetClass {
  messageKey: ExamPropertiesTabNames;
  propertyTabs: ExamPropertiesTabNames[];
  currentTab = 0;
  isReadOnly = false;

  // REFACTOR IDEA find out if we can use two-way data binding for the exam (create, edit, readOnly) to make services simpler
  prepExam: IExamModel | undefined;
  showErrorMessage = false;
  // by default readOnly because it's the type that the user can do the least
  examPropertiesType = ExamPropertiesType.readOnly;

  constructor(
    private readonly examSettingsTabService: ExamSettingsTabService,
  ) {
    this.propertyTabs = this.examSettingsTabService.propertyTabs;
    
    const lastTab = this.examSettingsTabService.getLastTab;
    this.handleChangeTab(this.propertyTabs[lastTab]);
    this.examSettingsTabService.setLastTab(lastTab, true);
  }

  getWindowType(): Type<IModalWindow> {
    return ExamPropertiesComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.EXAM_MODE_PROPERTIES_WINDOW;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | ISetOptions | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      default: return null;
    }
  }

  setOptions(options: ExamPropertiesOptions): void {
    this.messageKey = options.currentTab ?? ExamPropertiesTabNames.Document;
    this.prepExam = options.exam;
    this.examPropertiesType = options.type

    // TODO (REFACTOR IDEA ) needs to be replace by type
    this.isReadOnly = this.examPropertiesType === ExamPropertiesType.readOnly;
  }

  getClass(): string {
    return 'exam-properties-modal';
  }

  handleChangeTab(name: ExamPropertiesTabNames): void {
      this.messageKey = name;
      this.setCurrentTab(this.propertyTabs.indexOf(name));
  }

  clickNavigate(direction: number) { // direction should be a number: +1 or -1
      const newTab = this.currentTab + direction;
      if (newTab >= 0 || newTab < this.propertyTabs.length) {
        this.messageKey = this.propertyTabs[newTab];
        this.setCurrentTab(newTab);
      }
  }

  private setCurrentTab(id: number) {
    if (id >= 0) {
      this.currentTab = id;
      this.examSettingsTabService.setLastTab(id);
    }
  }

  goToUnlockTab(): void {
    // this.messageKey = examPropertiesTabNames.UnlockCode;
  }
}
